import React from 'react';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import BillingTo from './BillingTo';

import { I_Colors, I_Data } from '../propTypes';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: '-30px -40px 0px -40px',
  },
  superHeader: {
    height: 90,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
    paddingLeft: '40px',
    paddingRight: '40px',
  },
  infoContainer: {
    color: 'white',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    top: 28,
    left: 425,
    width: 140,
    fontSize: 7,
    fontWeight: 400,
  },
  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  typeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '34%',
  },
  type: {
    fontSize: 30,
    letterSpacing: 1.08,
    fontWeight: 500,
    textTransform: 'uppercase',
    marginBottom: 1,
  },
  companyContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    width: '66%',
  },
  companyLogo: {
    height: 56,
    width: 56,
    overflow: 'hidden',
    borderRadius: 4,
  },
  companyCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
  },
  companyName: {
    fontSize: 14,
    fontWeight: 500,
  },
  companySlogan: {
    fontSize: 9,
    fontWeight: 300,
  },
});

function Header({ data, colors }: { data: I_Data; colors: I_Colors }) {
  return (
    <View style={styles.container}>
      <View
        style={{
          ...styles.superHeader,
          backgroundColor: colors.color1,
          color: colors.color1text,
        }}
      >
        <View style={styles.companyContainer}>
          {data.user.company?.logo ? (
            <Image style={styles.companyLogo} src={data.user.company.logo} />
          ) : null}
          <View style={{ ...styles.companyCol, color: colors.color1text }}>
            <Text style={styles.companyName}>{data.user.company.name}</Text>
            {data.user.company?.slogan ? (
              <Text style={styles.companySlogan}>
                {data.user.company.slogan}
              </Text>
            ) : null}
          </View>
        </View>
        <View style={styles.typeContainer}>
          <Text style={styles.type}>{data.type}</Text>
        </View>
      </View>

      <BillingTo data={data} colors={colors} />
    </View>
  );
}

export default Header;
